export async function postProcessUpsert<T>(res: Response) {
  if (res.status > 399 && res.status < 600) {
    const detail = (await res.json()).detail;
    if (typeof detail === 'string') {
      throw new Error(detail);
    } else {
      // only the first error
      throw new Error(detail?.[0]?.msg || "An unknown error has occurred");
    }
  }
  return res.json() as Promise<T>;
}

export async function postProcessDelete(res: Response) {
  if (res.status > 399 && res.status < 600) {
    const detail = (await res.json()).detail;
    throw new Error(detail);
  }
}
